import { createRouter, createWebHashHistory } from 'vue-router'

import ViewOfIndex from '@/views/indexView.vue'
import ViewOfImageTypes from '@/views/imageTypesView.vue'

// 登录视图和管理视图等基本视图引入
import ViewOfUserCenter from '@/views/userCenterView.vue'

// 查看图片
import ViewOfImageList from '@/views/lmageListView.vue'
import imageListBarrel from '@/components/image/imgsList/imageListBarrel'
import imageShowConvas from '@/components/image/imgCanvas/imageShowCanvas'

// 用户中心子路由
import UserInfo from '@/components/userCenter/userInfoRelevant/userInfo.vue'
import ShopRecords from '@/components/userCenter/shopRecords.vue'
import UserResetPasswdDialog from '@/components/userCenter/userInfoRelevant/resetPassword.vue'
import userFavoritesImagesCom from '@/components/userCenter/userImageRelevant/favoriteImages/favImagesList.vue'
import historyCom from '@/components/userCenter/userImageRelevant/readHistory/historyDialog.vue'

// 用户购物车路由视图
import ViewOfUserShopping from '@/views/userShoppingView.vue'

// 用户反馈路由视图
import ViewOfFeedBack from '@/views/feedBackListView.vue'

const routes = [
  {
    path: '/',
    component: ViewOfIndex
  },
  {
    path: '/imgTypes', // 分类图片概览页面
    component: ViewOfImageTypes
  },
  {
    path: '/imgList', // 检索阅读页面
    component: ViewOfImageList,
    children: [
      {
        path: 'barrel',
        component: imageListBarrel
      },
      {
        path: 'convas',
        component: imageShowConvas
      }
    ]
  },
  {
    path: '/userCenter', // 用户中心页面
    component: ViewOfUserCenter,
    children: [
      // 子路由路径前会自动添加添加斜杠
      {
        path: 'info',
        component: UserInfo
      }, // 进入用户中心的账号信息修改页面
      {
        path: 'shopRecords',
        component: ShopRecords
      }, // 进入用户中心的充值信息页面
      {
        path: 'resetPasswd',
        component: UserResetPasswdDialog
      },
      {
        path: 'collection',
        component: userFavoritesImagesCom
      },
      {
        path: 'history',
        component: historyCom
      }
    ]
  },
  {
    path: '/userShopping', // 进入我要购买
    component: ViewOfUserShopping
  },
  {
    path: '/feedBack', // 进入用户留言
    component: ViewOfFeedBack
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
